import type { LinkProps } from '@tanstack/react-router';

import type { AuditLogEntry } from '@nucleus-commerce/api-client/admin';

/**
 * The screen an audit row points at, when one exists. Store-scoped entities need the row's
 * store; deleted records still link and the target shows its own not-found state.
 */
export function entityLink(entry: AuditLogEntry): LinkProps | null {
  const { entityType, entityId, storeId } = entry;
  switch (entityType) {
    case 'organization':
      return { to: '/org/settings' };
    case 'store':
      return entityId ? { to: '/org/stores/$storeId', params: { storeId: entityId } } : null;
    case 'membership':
      return { to: '/org/team' };
    case 'role':
      return { to: '/org/roles' };
    case 'product':
      return entityId ? { to: '/org/products/$productId', params: { productId: entityId } } : null;
    case 'store_product':
      return entityId && storeId
        ? {
            to: '/s/$storeId/catalog/$storeProductId',
            params: { storeId, storeProductId: entityId },
          }
        : null;
    case 'order':
      return entityId && storeId
        ? { to: '/s/$storeId/orders/$orderId', params: { storeId, orderId: entityId } }
        : null;
    case 'customer':
      return entityId && storeId
        ? { to: '/s/$storeId/customers/$customerId', params: { storeId, customerId: entityId } }
        : null;
    case 'api_key':
      return storeId ? { to: '/s/$storeId/settings/api-keys', params: { storeId } } : null;
    case 'webhook_endpoint':
      return entityId && storeId
        ? {
            to: '/s/$storeId/settings/webhooks/$endpointId',
            params: { storeId, endpointId: entityId },
          }
        : null;
    default:
      return null;
  }
}
